import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import get from 'lodash/get';
import find from 'lodash/find';
import ReactDOMServer from 'react-dom/server';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Settings from 'yoda-core-components/lib/assets/svg/Settings.svg';
import PrintIcon from 'yoda-core-components/lib/assets/svg/Print.svg';
import ShareLink from 'yoda-core-components/lib/assets/svg/ShareLink.svg';
import PublicIcon from 'yoda-core-components/lib/assets/svg/PublicIcon.svg';
import Lock from 'yoda-core-components/lib/assets/svg/Lock.svg';
import Copy from 'yoda-core-components/lib/assets/svg/Copy.svg';
import User from 'yoda-site-components/lib/helpers/User/User';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import time from 'yoda-core-components/lib/moment/Time';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
/* eslint-disable import/no-named-as-default */
import Button from 'yoda-core-components/lib/components/Button';
import CopyListPanel from '../../CopyListPanel/CopyListPanel';
import SelectedList from '../SelectedList/SelectedList';
import SortPanel from '../SortPanel/SortPanel';
import CreateListDropDown from '../CreateListDropDown/CreateListDropDown';
import Print from '../Print/Print';
import ListSettings from '../../NewListSettings/ListSettings';
import MyShareSlider from '../../MyShareSlider/MyShareSlider';
import { doSoftNavigate } from '../../../common/UrlHelper';

class FilterPanel extends Component {
    static defaultProps = {
        featureFlags: {},
        preferences: {},
        myListsDetails: {},
        messagesTexts: {},
        openSlider: {},
        authStatus: false,
        isTrending: false,
        typeInfoTheme: {},
        headers: {},
    };

    static propTypes = {
        myListsDetails: PropTypes.objectOf(PropTypes.object),
        actions: PropTypes.objectOf.isRequired,
        featureFlags: PropTypes.objectOf(PropTypes.object),
        preferences: PropTypes.objectOf(PropTypes.object),
        savedList: PropTypes.objectOf.isRequired,
        shareList: PropTypes.objectOf.isRequired,
        savedListActions: PropTypes.objectOf(PropTypes.object).isRequired,
        messagesTexts: PropTypes.objectOf(PropTypes.object),
        authStatus: PropTypes.bool,
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
            basename: PropTypes.string.isRequired,
            query: PropTypes.objectOf(PropTypes.object).isRequired,
            search: PropTypes.string.isRequired,
        }).isRequired,
        openSlider: PropTypes.func,
        getListCategorySort: PropTypes.func.isRequired,
        accounts: PropTypes.objectOf.isRequired,
        showTopMessage: PropTypes.func.isRequired,
        isTrending: PropTypes.bool,
        typeInfoTheme: PropTypes.objectOf,
        headers: PropTypes.objectOf(PropTypes.object),
        deviceType: PropTypes.objectOf.isRequired,
        isShared: PropTypes.bool.isRequired,
    };

    constructor(props) {
        super();
        const accountId = props.featureFlags.enableServerSideRendering
            ? props.headers.cookies.ACCOUNT_ID
            : TokenProvider.get('ACCOUNT_ID');
        const search = get(props, 'location.search', '');
        const query = makeQuery(search);
        const listId = get(query, 'id', 'myFavorites');
        this.state = {
            openCreateListDropdown: false,
            listId,
            showSlider: false,
            showMyShareListSlider: false,
            accountId,
        };
    }

    /* eslint-disable camelcase */
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { accounts: { userState = '' } = {}, myListsDetails = {} } = nextProps;
        const { listItems: { listData = {} } = {} } = myListsDetails;
        const { accounts = {} } = this.props;

        if (listData && userState && userState !== accounts.userState) {
            if (userState === '0') {
                const { location } = this.props;
                const search = get(location, 'search', '');
                const query = makeQuery(search);
                const listId = get(query, 'id', 'myFavorites');
                listId === 'myFavorites'
                    ? this.props.savedListActions.getSavedListsGuest()
                    : window.location.assign('/mylist');
            } else {
                this.props.actions.getLists();
            }
        }
    }

    onSuccessCopiedList = (id, name) => {
        this.props.actions.getLists();
        this.props.actions.showCopyListSuccessMessage({ show: true, name });

        if (this.props.isShared) {
            doSoftNavigate('/savedlist', { id });
        } else {
            doSoftNavigate('/mylist', { id });
        }
    };

    settings = () => {
        this.props.savedListActions.trackIconEvent('openModalListSettings');
        const authStatus = TokenProvider.get('DP_USER_STATE') || '0';
        if (authStatus !== '1') {
            this.props.openSlider();
        } else {
            this.setState({ showSlider: true });
        }
    };

    getListTypeInfo = () => {
        const { myListsDetails = {}, messagesTexts, savedList, isShared, isTrending } = this.props;
        const { listId } = this.state;
        const { listItems: { listData = {} } = {} } = myListsDetails;
        const requestObj = { ...myListsDetails };
        delete requestObj.listItems;
        const defaultValue = {
            name: 'My Favorites',
            isPublic: false,
            id: 'myFavorites',
        };
        let selectedList = find(listData, (item) => item.id === listId);
        if (isShared) {
            selectedList = {
                id: get(savedList, 'data.id'),
                name: get(savedList, 'data.name'),
                isPublic: true,
            };
        }
        const {
            filterPanel: { privacyLabel: { publicList = '', privateList = '' } = {} } = {},
        } = messagesTexts.myListing;
        const { isPublic = false } = selectedList || defaultValue;
        const curatorName = get(savedList, 'data.ownerName', '');
        const privacyLabel = isPublic ? publicList : privateList;
        const privacyIconComponent = isPublic ? <PublicIcon /> : <Lock />;

        const showIconLabel = !isShared || isTrending;

        return (
            <div className={dt(['smOnly:inline-block', 'flex', 'items-center'])}>
                {showIconLabel && (
                    <>
                        <Icon
                            pathClassName={dt(['mr-1'])}
                            iconType="svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                        >
                            {privacyIconComponent}
                        </Icon>
                        <span
                            className={dt([
                                'text-medium',
                                'font-semibold',
                                'inline-block',
                                'align-middle',
                                'text-black',
                                'ml-2',
                            ])}
                        >
                            {privacyLabel}
                        </span>
                    </>
                )}
                {isShared && (
                    <span
                        className={dt([
                            'text-small',
                            'font-open-sans-regular',
                            'inline-block',
                            'align-middle',
                            'text-gray-60',
                            'ml-1',
                            'smOnly:mt-4',
                            'smOnly:ml-0',
                            'smOnly:block',
                        ])}
                    >
                        {isTrending ? <span className={dt(['smOnly:hidden'])}>|</span> : ''} Curated
                        by {curatorName}
                    </span>
                )}
            </div>
        );
    };

    shareMyList = () => {
        if (this.checkAuth()) {
            this.props.savedListActions.shareListReset();
            this.props.savedListActions.trackIconEvent('modal:share list');
            this.setState({ showMyShareListSlider: true });
        }
    };

    checkAuth = () => {
        if (!User.isUserLoggedIn()) {
            this.props.openSlider();
            return false;
        }
        return true;
    };

    deleteListClicked = (listId) => {
        if (this.checkAuth() && this.state.accountId) {
            this.props.actions.deleteList(listId);
        }
    };

    saveToClicked = (listName, currentPrivacySetting, eventDate, listId) => {
        const param = {
            data: [
                {
                    op: 'replace',
                    path: '/name',
                    value: listName,
                },
                {
                    op: 'replace',
                    path: '/eventDate',
                    value: eventDate || null,
                },
                {
                    op: 'replace',
                    path: '/isPublic',
                    value: currentPrivacySetting,
                },
            ],
            listId,
        };

        if (this.state.accountId) {
            this.props.actions.saveToList(param);
            this.setState({ listId });
        }
    };

    closeModal = (isSuccess) => {
        if (isSuccess) {
            this.props.actions.getLists();
        }
        this.props.actions.resetList();
        this.setState({ showSlider: false, showMyShareListSlider: false });
    };

    openCreateListDropdown = () => {
        const listDropDown = this.state.openCreateListDropdown;
        this.setState({
            openCreateListDropdown: !listDropDown,
        });
    };

    copyList = () => {
        const copyList = this.state.openCopyList;
        if (this.checkAuth()) {
            this.setState({
                openCopyList: !copyList,
            });
        }
    };

    print = () => {
        this.props.savedListActions.trackIconEvent('openModalPrintList');
        const left = 24.3;
        const top = 23;
        const printDetailsView = (savedList) => {
            const printListView = [];
            const username = savedList.data.ownerName;
            const divStyle = {
                maxWidth: '612px',
                margin: '0 auto',
            };
            const listName = {
                fontFamily: 'OpenSans',
                fontSize: '14px',
                fontWeight: 'bold',
                lineHeight: '1.71',
                color: '#384048',
            };
            const userName = {
                fontSize: '12px',
                lineHeight: '2',
                color: '#1c2024',
                fontWeight: 'normal',
            };
            const dateSection = {
                textAlign: 'right',
            };
            const printedDate = {
                fontFamily: 'OpenSans',
                fontSize: '12px',
                lineHeight: '1.33',
                color: '#1c2024',
            };
            const note = {
                fontFamily: 'OpenSans',
                fontSize: '10px',
                fontWeight: 'italic',
                lineHeight: '1.71',
                color: '#53606b',
            };
            const bold = {
                fontWeight: 'bold',
            };
            const headerContent = {
                display: 'flex',
                justifyContent: 'space-between',
            };
            const logo = {
                width: '182px',
            };
            if (get(savedList, 'data.items')) {
                for (let i = 0; i < savedList.data.items.length; i += 1) {
                    printListView.push(
                        <div>
                            <Print savedListItem={savedList.data.items[i]} />
                        </div>
                    );
                }
                return (
                    <div>
                        <div style={divStyle}>
                            <header>
                                <div style={headerContent}>
                                    <img
                                        src={get(
                                            this.props.preferences,
                                            'printLogoImage',
                                            'https://www.jcpenney.com/static-listing/assets/images/jcp-logo-new.png'
                                        )}
                                        style={logo}
                                        alt="JCPenney"
                                    />
                                    <div style={dateSection}>
                                        <p style={printedDate}>
                                            Printed {time().format('MM/DD/YYYY')}
                                        </p>
                                        <p style={note}>
                                            Prices and availability may vary by store
                                        </p>
                                    </div>
                                </div>
                                <p style={listName}>
                                    {!this.props.isShared && (
                                        <div>
                                            <span style={bold}>List:</span> {savedList.data.name}
                                        </div>
                                    )}
                                    {this.props.isShared && (
                                        <div>
                                            <span style={bold}>Shared List:</span>{' '}
                                            {savedList.data.name}
                                        </div>
                                    )}
                                    {this.props.isShared && (
                                        <div style={userName}>Curated by {username}</div>
                                    )}
                                </p>
                            </header>
                            {printListView}
                        </div>
                    </div>
                );
            }
            return null;
        };
        const htmlString = ReactDOMServer.renderToStaticMarkup(
            printDetailsView(this.props.savedList)
        );
        const printWindow = window.open('', 'PRINT', `width=700,left=${left},top=${top}`);
        printWindow.document.write('</head><body >');
        printWindow.document.write(htmlString);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        let isPrinting = false;
        printWindow.onload = () => {
            // wait until all resources loaded
            isPrinting = true;
            printWindow.focus(); // necessary for IE >= 10
            printWindow.print(); // change window to printWindow
            printWindow.close(); // change window to mywindow
            isPrinting = false;
        };
        setTimeout(() => {
            if (!isPrinting) {
                printWindow.print();
                printWindow.close();
            }
        }, 500);
    };

    listNamePadding = (value) => {
        return value;
    };

    render() {
        const {
            myListsDetails = {},
            messagesTexts,
            savedListActions,
            deviceType,
            getListCategorySort,
            savedList,
            shareList,
            location,
            isTrending,
            preferences,
            actions,
            showTopMessage,
            isShared,
            openSlider,
        } = this.props;
        const {
            openCreateListDropdown,
            openCopyList,
            listId,
            showSlider,
            showMyShareListSlider,
        } = this.state;
        const { listItems: { listData = {} } = {} } = myListsDetails;
        const requestObj = { ...myListsDetails };
        delete requestObj.listItems;
        const defaultValue = {
            name: 'My Favorites',
            isPublic: false,
            id: 'myFavorites',
        };
        const {
            filterPanel: { privacyLabel: { eventDate: eventDT = '' } = {} } = {},
        } = messagesTexts.myListing;
        let selectedList = find(listData, (item) => item.id === listId);
        if (isShared) {
            selectedList = {
                id: get(savedList, 'data.id'),
                name: get(savedList, 'data.name'),
                isPublic: true,
                sourceAccountId: get(savedList, 'data.accountId'),
            };
        }
        const { name = '', eventDate, sourceAccountId, isPublic = false, id = '', type = '' } =
            selectedList || defaultValue;
        const isMyFavorites = type === 'myFavorites';
        const totalProducts = get(savedList, 'data.items', []).length;
        const date = get(savedList, 'data.date', '');
        const dateLabel = date ? `${time(date).format('MM/DD/YYYY')}` : '';
        const eventDateLabel = eventDate ? `${time(eventDate).format('MM/DD/YYYY')}` : '';
        const listSettingProps = {
            saveToList: requestObj,
            listName: name,
            eventDate,
            isPublic,
            saveToClicked: this.saveToClicked,
            listId: id,
            closeModal: this.closeModal,
            showSlider,
            isMyFavorites,
            deleteListClicked: this.deleteListClicked,
            messagesTexts,
            preferences,
            actions,
            myListsDetails,
        };
        const listName = this.listNamePadding(name);
        const { isTablet, isDesktop, isMobile } = deviceType;
        return (
            <div
                data-automation-id="filter-panel"
                className={dt(['text-xLg', isTrending ? 'mt-6' : ''])}
            >
                <div className={isTrending && dt(['flex', 'justify-between', 'items-start'])}>
                    {!isTrending && (
                        <div className={dt(['w-full', 'inline-block', 'mb-4', 'smOnly:mb-0'])}>
                            {' '}
                            <SelectedList
                                listName={listName}
                                clickHandler={this.openCreateListDropdown}
                                isShared={isShared}
                                listId={listId}
                                deviceType={deviceType}
                            >
                                {openCreateListDropdown && (
                                    <CreateListDropDown
                                        clickHandler={this.openCreateListDropdown}
                                        showTopLevelMessage={showTopMessage}
                                        openSlider={openSlider}
                                    />
                                )}
                            </SelectedList>
                        </div>
                    )}
                    <div className={dt(['flex', 'justify-between', 'w-full', 'md:h-[48px]'])}>
                        {this.getListTypeInfo()}
                        <div className={dt(['smOnly:items-start', 'flex', 'items-center'])}>
                            {isShared && totalProducts > 0 && (
                                <div className={dt(['inline-block', '!pr-4'])}>
                                    <Button
                                        buttonType="Link"
                                        automationId="listhub-custom-list-copy"
                                        onClick={this.copyList}
                                    >
                                        <Icon
                                            iconType="svg"
                                            className={dt(['h-6', 'w-6', 'smOnly:ml-2'])}
                                            width="24px"
                                            height="24px"
                                            viewBox="0 0 24 24"
                                        >
                                            <Copy />
                                        </Icon>
                                    </Button>
                                    {id && openCopyList && (
                                        <CopyListPanel
                                            sourceAccountId={sourceAccountId}
                                            sourceListId={id}
                                            sourceListName={name}
                                            onSuccess={this.onSuccessCopiedList}
                                            onClose={this.copyList}
                                        />
                                    )}
                                </div>
                            )}
                            {totalProducts > 0 && (
                                <Button
                                    buttonType="Link"
                                    automationId="listhub-custom-list-settings"
                                    onClick={this.shareMyList}
                                    className={dt(['!pr-4', isTrending && !isDesktop && 'pr-0'])}
                                >
                                    <Icon
                                        iconType="svg"
                                        width="32px"
                                        height="32px"
                                        className={dt(['fill-black', 'w-6', 'h-6'])}
                                        viewBox="0 0 32 32"
                                    >
                                        <ShareLink />
                                    </Icon>
                                </Button>
                            )}
                            {totalProducts > 0 && (
                                <Button
                                    buttonType="Link"
                                    automationId="listhub-custom-list-settings"
                                    className={dt(['ml-0', !isTrending && '!pr-4', 'smMd:hidden'])}
                                    onClick={this.print}
                                >
                                    <Icon
                                        iconType="svg"
                                        width="32px"
                                        height="32px"
                                        viewBox="0 0 32 32"
                                        className={dt(['h-6', 'w-6'])}
                                    >
                                        <PrintIcon />
                                    </Icon>
                                </Button>
                            )}
                            {!isShared && (
                                <Button
                                    buttonType="Link"
                                    automationId="listhub-custom-list-settings"
                                    onClick={this.settings}
                                >
                                    <Icon
                                        iconType="svg"
                                        width="32px"
                                        height="32px"
                                        viewBox="0 0 32 32"
                                        className={dt(['h-6', 'w-6'])}
                                    >
                                        <Settings />
                                    </Icon>
                                </Button>
                            )}
                            {(isDesktop || isTablet) && totalProducts > 0 && (
                                <SortPanel
                                    preferences={preferences}
                                    disabled={totalProducts <= 1}
                                    authStatus={this.props.authStatus}
                                    listId={id}
                                    getListCategorySort={getListCategorySort}
                                    isMyFavorites={isMyFavorites}
                                    deviceType={this.props.deviceType}
                                />
                            )}
                        </div>
                    </div>
                </div>
                {isMobile && totalProducts > 0 && (
                    <SortPanel
                        preferences={preferences}
                        disabled={totalProducts <= 1}
                        authStatus={this.props.authStatus}
                        listId={id}
                        getListCategorySort={getListCategorySort}
                        isMyFavorites={isMyFavorites}
                        deviceType={this.props.deviceType}
                    />
                )}
                {(!isShared || isTrending) && dateLabel && (
                    <div className={dt(['mt-4', 'leading-5', 'flex', 'smOnly:justify-between'])}>
                        <span
                            className={dt([
                                'text-small',
                                'font-semibold',
                                'inline-block',
                                'align-middle',
                            ])}
                        >
                            Created:
                            <span className={dt(['text-small', 'font-normal', 'ml-2'])}>
                                {dateLabel}
                            </span>
                        </span>
                        {eventDateLabel && (
                            <span
                                className={dt([
                                    'text-small',
                                    'font-semibold',
                                    'inline-block',
                                    'align-middle',
                                    'ml-6',
                                    'smOnly:ml-0',
                                ])}
                            >
                                Event Date:
                                <span className={dt(['text-small', 'font-normal', 'ml-2'])}>
                                    {eventDateLabel}
                                </span>
                            </span>
                        )}
                    </div>
                )}
                {showSlider && (
                    /* eslint-disable react/jsx-props-no-spreading */
                    <ListSettings {...listSettingProps} />
                )}
                {showMyShareListSlider && (
                    <MyShareSlider
                        showMyShareListSlider={showMyShareListSlider}
                        messagesTexts={messagesTexts.myListing}
                        actions={savedListActions}
                        savedList={savedList}
                        shareList={shareList}
                        location={location}
                        closeModal={this.closeModal}
                        listId={id}
                        isProductsEmpty={totalProducts === 0}
                        listSettingProps={listSettingProps}
                    />
                )}
            </div>
        );
    }
}

export default FilterPanel;
